import { useState } from 'react';
import { FormContainer } from '../../../_core/form/form-container.component';
import { FetchUserInviteCodeNestedContainer } from './fetch-user-invite-code-form-nested.container';
import { Emailable, Identifiable } from '../../../../lib/types';
import { IRequestAccess } from '../user-invite-code.types';

interface IFetchUserInviteCodeContainer extends IRequestAccess {
  code?: string;
  onBack: () => void;
  onSubmit: (_: Identifiable & Emailable) => void;
}

export const FetchUserInviteCodeContainer = (props: IFetchUserInviteCodeContainer) => {
  const [success, setSuccess] = useState<string | null>(null);
  const [submitError, setSubmitError] = useState<string | null>(null);

  return (
    <FormContainer
      error={submitError}
      setError={setSubmitError}
      success={success}
      setSuccess={setSuccess}
      title="Create Account"
    >
      <FetchUserInviteCodeNestedContainer
        {...props}
        onError={(e) => setSubmitError(e ?? null)}
        onSuccess={(s) => setSuccess(s ?? null)}
      />
    </FormContainer>
  );
};
